import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Phone, MessageCircle, FileText } from "lucide-react";
import { useLang, CONTACTS } from "../i18n";
import { Reveal } from "./Reveal";
import { scrollToId } from "../lib/scroll";

export const CtaBanner = () => {
  const { t } = useLang();
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], [-60, 60]);

  return (
    <section ref={ref} data-testid="cta-banner" className="relative overflow-hidden border-y border-white/10">
      <motion.div style={{ y }} className="absolute inset-0 z-0 scale-125">
        <img
          src="https://images.unsplash.com/photo-1526289034009-0240ddb68ce3?q=80&w=2000&auto=format&fit=crop"
          alt=""
          loading="lazy"
          className="h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-black/75" />
      </motion.div>
      <div className="relative z-10 mx-auto max-w-[1500px] px-5 py-28 md:px-10 md:py-40">
        <Reveal>
          <h2 className="max-w-4xl font-display text-4xl sm:text-6xl lg:text-7xl uppercase leading-[0.95] tracking-wide">
            {t.cta.title}
          </h2>
        </Reveal>
        <Reveal delay={0.12}>
          <p className="mt-6 max-w-xl text-sm md:text-lg text-neutral-300">{t.cta.sub}</p>
        </Reveal>
        <Reveal delay={0.2} className="mt-10 flex flex-wrap gap-4">
          <a
            data-testid="cta-call-btn"
            href={CONTACTS.phoneHref}
            className="flex items-center gap-3 bg-[#FF5A00] px-7 py-4 text-xs font-bold uppercase tracking-widest text-white transition-colors hover:bg-[#E04F00]"
          >
            <Phone size={16} /> {t.cta.call}
          </a>
          <a
            data-testid="cta-whatsapp-btn"
            href={CONTACTS.whatsapp}
            target="_blank"
            rel="noreferrer"
            className="flex items-center gap-3 border border-white/25 px-7 py-4 text-xs font-bold uppercase tracking-widest transition-colors hover:border-[#FF5A00] hover:text-[#FF5A00]"
          >
            <MessageCircle size={16} /> {t.cta.whatsapp}
          </a>
          <button
            data-testid="cta-quote-btn"
            onClick={() => scrollToId("#contacts")}
            className="flex items-center gap-3 border border-white/25 px-7 py-4 text-xs font-bold uppercase tracking-widest transition-colors hover:border-[#FF5A00] hover:text-[#FF5A00]"
          >
            <FileText size={16} /> {t.cta.quote}
          </button>
        </Reveal>
      </div>
    </section>
  );
};
